import * as Yup from 'yup'

import { confirmNewPin, confirmPin, email, newPin, pin } from 'utils/yup'

export const CHANGE_PIN_SCHEMA = Yup.object().shape({ pin, newPin, confirmNewPin })

export const CREATE_PIN_SCHEMA = Yup.object().shape({ pin, confirmPin })

export const RESET_PIN_SCHEMA = Yup.object().shape({ email })
